/* eslint-disable prettier/prettier */
import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

interface StyleProps {
  useBrandColor?: boolean;
}

const styles = makeStyles(() => {
  return {
    item: {
      marginTop: 0,
    },
    customTimelineDot: ({ useBrandColor }: StyleProps) => ({
      boxShadow: "none",
      color: "#308CDB",
      margin: 0,
      ...(useBrandColor
        ? {
            borderColor: colors.brandBlue500,
          }
        : {
            backgroundColor: "#EDF5FB",
          }),
    }),
    line: ({ useBrandColor }: StyleProps) => ({
      height: "1px",
      width: "100%",
      ...(useBrandColor
        ? {
            backgroundColor: colors.brandBlue500,
          }
        : {
            backgroundColor: "#CCDEEE",
          }),
    }),
    subTitle: {
      fontSize: "12px",
      lineHeight: "18px",
      color: "#93A9BD",
      fontWeight: 700,
    },
    connector: ({ useBrandColor }: StyleProps) =>
      useBrandColor
        ? {
            backgroundColor: colors.brandBlue500,
            width: "1px",
          }
        : {
            backgroundColor: "#308cdb",
            boxShadow: "inset 2px 0 0 #308cdb",
          },
    title: {
      fontSize: "16px",
      lineHeight: "18px",
      color: "#465869",
    },
    grid: {
      height: "70%",
    },
    content: {
      padding: "0 10px",
      "@media screen and (max-width: 1400px)": {
        "& > div": {
          display: "flex",
          flexWrap: "nowrap !important",
        },
      },
    },
    opposite: {
      display: "none",
    },
  };
});

export default styles;
